import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { MarketingCampaignCSVInput } from "./input";
import { MarketingCampaignList } from "./target-list/root";

export const QuestionCampaignList = () => {
	return (
		<FeatureIslandMainWithBackGround islandTitle="対象者リスト">
			<div className="flex flex-col gap-y-4">
				<MarketingCampaignCSVInput />
				<MarketingCampaignList />
			</div>
		</FeatureIslandMainWithBackGround>
	);
};
QuestionCampaignList.displayName = "QuestionCampaignList";
